import httpService from "./httpService";
import utils from "./utils";

export default {
  findById(id) {
    return httpService.get("vbStep/" + id);
  },

  findAllByFlowId(flowId) {
    return httpService.get("vbStep/findAllByFlowId", { params: { flowId } });
  },

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbStep", { params: params });
  },

  findByStepIdAndDelegateId(stepId, delegateInfoId) {
    return httpService.get("vbStep/findByStepIdAndDelegateId", { params: { stepId, delegateInfoId } });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbStepService.js